import axios from 'axios';
import { assignCancelToken } from '@/api/utils';
import { searchUniversities } from '@/api/gateway/legacy-api/search';
import { gateway } from '..';
import type { DegreeTypeResource } from './resources/DegreeTypeResource';
import type { InstitutionType } from './resources/UniversityResource';
import type { CourseResource } from './resources/CourseResource';

export function getUniversities(params: unknown) {
    const cancelToken = axios.CancelToken.source();
    const promise = gateway.get<
        Array<{
            active: number;
            city: string;
            country?: unknown;
            country_id: number;
            degree_program_count: number;
            description?: string;
            image?: string;
            institution_type: InstitutionType;
            name: string;
            st_active: number;
            synonyms: unknown;
            university_id: number;
            users_count: number;
        }>
    >(`legacy-api/v1/universities`, {
        params,
        cancelToken: cancelToken.token,
    });
    return assignCancelToken(promise, cancelToken);
}

export function getInstitutions() {
    return searchUniversities({
        institution_type: 0,
    });
}

export function getCourses(universityId: number | string) {
    return gateway.get<CourseResource[]>(`/legacy-api/v1/universities/${universityId}/courses`);
}

export function getDegreeTypes(uniId: number, descOrder = false) {
    const cancelToken = axios.CancelToken.source();
    const promise = gateway.get<DegreeTypeResource[]>(
        `legacy-api/v1/universities/${uniId}/degree_program/degree_types`,
        {
            params: {
                order: descOrder ? 'desc' : 'asc',
            },
            cancelToken: cancelToken.token,
        },
    );
    return assignCancelToken(promise, cancelToken);
}
